import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SupportLinkDirective } from './support-link.directive';

@NgModule({
  declarations: [SupportLinkDirective],
  exports: [SupportLinkDirective],
  imports: [CommonModule],
})
export class SupportLinkModule {}
